import ApiService from '../../../../../../services/ApiService'
import CalibrationDataTable from '../CalibrationDataTable/CalibrationDataTable.vue'
import DepartmentInactive from '../../../../Department/deparmentInactive/departmentInactive.vue'
import Utils from '../../../../../../Utils/FormatDate'

export default {
  components: {
    CalibrationDataTable,
    DepartmentInactive,
  },

  created() {
    this.currentUser = JSON.parse(localStorage.getItem('user'))
    this.institution = JSON.parse(localStorage.getItem('institution'))
    this.currentServiceOrder = JSON.parse(
      sessionStorage.getItem('serviceOrder')
    )
    this.inputDisabled =
      this.institution.userType > 3 || this.institution.userType != 8
    this.getTemplates()
    if (this.currentServiceOrder.calibrations.length > 0) {
      this.getCalibration()
    }
    this.getCalibrationMetrics()
    this.getCalibrationPatterns()

    this.footnote = `EQUIPACARE SERVICOS ESPECIALIZADOS DE APOIO TECNICO LTDA CNPJ: 17.040.595/0001-01
Endereço: R. 41-C, 611 - Vila Santa Cecília, Volta Redonda - RJ, 27255-430
Telefone: (24) 3348-7157
`
  },

  data: () => ({
    institution: {},
    step: 0,
    selectedTab: 0,
    errorMessage: '',
    successMessage: '',
    inputDisabled: false,
    loading: false,
    deleteDialog: false,
    templateLoading: false,
    deleteLoading: false,
    firstValid: true,
    alterDialog: false,
    signatureErrorDialog: false,
    printDialog: false,
    changedData: false,
    isEditing: false,
    error: false,
    showSuccess: false,
    departmentInactive: false,
    withoutValues: false,
    withoutValuesDialog: false,
    calibrationDateTimeError: false,
    tab: null,
    calibrationDateTime: null,
    resolutionEquipment: null,
    footnote: null,
    currentServiceOrder: {},
    currentCalibrationPatternTemplate: null,
    calibrationPatternTemplates: [],
    calibrationMetrics: [],
    calibrationTemplateParameters: [],
    calibrationMetricsRanges: [],
    calibrationParameters: [],
    currentUser: {},
    currentCalibration: {
      id: 0,
      calibrationDate: null,
      temperature: `25,00 ${String.fromCharCode(177)} 0,50 C`,
      relativeHumidity: `55,00 ${String.fromCharCode(177)} 5,00 %`,
      isExecutingSigned: false,
      executingUserId: null,
    },
    footnoteRules: [(v) => !!v || 'Rodapé é obrigatório'],
    apiService: new ApiService(),
  }),

  computed: {
    buttonText() {
      return this.isEditing ? 'Atualizar' : 'Adicionar'
    },
  },

  methods: {
    close() {
      sessionStorage.clear()
      let router = '/calibration'
      if (this.institution.userType > 4 && this.institution.userType != 8) {
        this.changedData = false
        router = '/serviceorders'
      }

      if (this.changedData) {
        this.alterDialog = true
      } else {
        this.$router.push(router)
      }
    },

    closeDialog() {
      this.changedData = false
      this.close()
    },

    setCalibrationNowDate() {
      this.calibrationDateTime = !this.calibrationDateTime
        ? new Date()
        : this.calibrationDateTime
    },

    editCalibrationData() {
      this.$router.push(`/calibrationCertified/${this.currentServiceOrder.id}`)
    },

    async openCertified() {
      if (this.withoutValues) {
        this.withoutValuesDialog = true
      } else {
        const route = this.$router.resolve({
          path: `printCalibrationCertified/${this.currentServiceOrder.institutionId}/${this.currentCalibration.id}`,
        })
        window.open(route.href, '_blank')
      }
    },

    showSuccessAlert(message) {
      this.successMessage = message
      this.showSuccess = true
      this.deleteDialog = false

      setTimeout(() => {
        this.showSuccess = false
      }, 2000)
    },

    formatDateTime(date) {
      if (!date) return
      return Utils.dateTime(date)
    },

    getMetricUnit(id) {
      return this.calibrationMetrics.find((x) => x.id === id).unit
    },

    getCalibrationPatternName(id) {
      return this.calibrationPatterns.find((x) => x.id === id).name
    },

    signCalibration() {
      if (this.withoutValues) {
        this.withoutValuesDialog = true
      } else {
        if (this.currentUser.signatureImage) {
          this.currentCalibration.isExecutingSigned = true
          this.currentCalibration.executingUserId = this.currentUser.id
          this.submit()
        } else {
          this.signatureErrorDialog = true
        }
      }
    },

    async getCalibration() {
      await this.apiService
        .get(
          `calibration/getByServiceOrder/${this.currentServiceOrder.institutionId}/${this.currentServiceOrder.id}`
        )
        .then((response) => {
          if (response.content) {
            this.isEditing = true
            this.currentCalibration = response.content
            this.calibrationDateTime = this.currentCalibration.calibrationDate
            this.currentCalibrationPatternTemplate =
              this.currentCalibration.calibrationPatternTemplate
            this.departmentInactive =
              response.content.equipment.department.status == 1
            this.footnote =
              response.content.footnote != null
                ? response.content.footnote
                : `EQUIPACARE SERVICOS ESPECIALIZADOS DE APOIO TECNICO LTDA CNPJ: 17.040.595/0001-01
Endereço: R. 41-C, 611 - Vila Santa Cecília, Volta Redonda - RJ, 27255-430
Telefone: (24) 3348-7157`
          }
        })
        .catch((err) => {
          this.errorMessage = err.body.message
          this.error = true

          if (err.status === 404) {
            this.$router.push('/calibration')
          }

          setTimeout(() => {
            this.error = false
          }, 4000)
        })
    },

    async getCalibrationMetrics() {
      await this.apiService.get('calibrationMetrics/list').then((response) => {
        this.calibrationMetrics = response.content
      })
    },

    async getCalibrationPatterns() {
      await this.apiService.get('calibrationPattern/list').then((response) => {
        this.calibrationPatterns = response.content
      })
    },

    async getTemplates() {
      this.templateLoading = true

      const model = {
        StandardEquipmentId:
          this.currentServiceOrder.equipment.standardEquipmentId,
        InstitutionId: this.currentServiceOrder.institutionId,
      }

      await this.apiService
        .post('calibrationPatternTemplate/listTemplate', model)
        .then((response) => {
          this.calibrationPatternTemplates = response.content
          this.templateLoading = false
        })
        .catch((err) => {
          this.templateLoading = false
        })
    },

    async submit() {
      if (this.$refs.firstForm.validate() && this.calibrationDateTime) {
        this.loading = true

        if (this.currentUser.signatureImage != null) {
          this.currentCalibration.isExecutingSigned = true
          this.currentCalibration.executingUserId = this.currentUser.id
        }

        const calibration = {
          Id: this.currentCalibration.id,
          InstitutionId: this.currentServiceOrder.institutionId,
          EquipmentId: this.currentServiceOrder.equipmentId,
          calibrationPatternTemplateId: this.isEditing
            ? this.currentCalibrationPatternTemplate.id
            : this.currentCalibrationPatternTemplate.calibrationPatternTemplate
                .id,
          ServiceOrderId: this.currentServiceOrder.id,
          CalibrationDate: Utils.nowDatetimeFormat(this.calibrationDateTime),
          Temperature: this.currentCalibration.temperature,
          RelativeHumidity: this.currentCalibration.relativeHumidity,
          isExecutingSigned: this.currentCalibration.isExecutingSigned,
          ExecutingUserId: this.currentCalibration.executingUserId,
          isValidatorSigned: this.currentCalibration.isValidatorSigned,
          ValidatorUserId: this.currentCalibration.validatorUserId,
          Footnote: this.footnote,
          Result: this.currentCalibration.result,
        }

        let calibrationModel = null
        if (!this.isEditing) {
          calibrationModel = {
            Calibration: calibration,
            Ranges:
              this.$refs.calibrationDataTable.calibrationParameterMetricRanges,
            Parameters:
              this.$refs.calibrationDataTable.calibrationTemplateParameters,
          }
        }

        let url = 'calibration/add'

        if (this.isEditing) {
          url = 'calibration/edit'
        }

        await this.apiService
          .post(url, this.isEditing ? calibration : calibrationModel)
          .then((response) => {
            this.closeDialog()
            this.showSuccessAlert(response.message)
          })
        this.loading = false
      } else {
        this.calibrationDateTime
          ? (this.calibrationDateTimeError = false)
          : (this.calibrationDateTimeError = true)

        if (this.calibrationDateTimeError) {
          this.$refs.firstForm.$el.scrollIntoView({ behavior: 'smooth' })
        }
      }

      this.loading = false
    },

    async removeCalibrationData() {
      this.deleteLoading = true

      await this.apiService
        .delete('calibration/deleteData', this.currentCalibration)
        .then((response) => {
          this.deleteLoading = false
          this.showSuccessAlert('Valores da calibração removido com sucesso')
          window.scrollTo(0, 0)
          this.currentCalibration = response.content
        })
    },

    parseDate(date) {
      if (!date) return null

      const dateTimeSplit = date.split(' ')

      const [day, month, year] = dateTimeSplit[0].split('/')
      const time = dateTimeSplit[1]

      if (time) {
        return `${year}-${month.padStart(2, '0')}-${day.padStart(
          2,
          '0'
        )} ${time}:00`
      }

      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
    },

    formatInputDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('T')[0].split('-')
      return `${day}/${month}/${year}`
    },
  },

  watch: {
    currentCalibration: {
      deep: true,
      handler() {
        this.changedData = true
      },
    },

    calibrationDateTime: {
      deep: true,
      handler() {
        this.changedData = true
        this.calibrationDateTimeError = false
      },
    },
  },
}
